<section class="w-full h-full overflow-auto hide-scroll flex flex-wrap content-start" infiniteScroll
  [infiniteScrollDistance]="1" [scrollWindow]="false" [infiniteScrollThrottle]="1000" (scrolled)="loadMore()">
  <article class="w-full flex flex-wrap">
    <app-header class="sticky top-0   z-30 bg-white dark:bg-gray-900 shadow-sm" [_Config]="headerConfig">
    </app-header>
    <div class="w-full flex flex-wrap mt-3 px-4">
      <ng-container *ngIf="!loading; else skeletonTemplate">
        <div *ngFor="let quote of quotes" class="w-full flex flex-wrap">
          <div class="w-full mb-3 pb-3 flex flex-wrap border-b border-gray-100 dark:border-gray-600">
            <!-- ? Actor -->
            <app-user-activity-info class="w-full" [User]="quote | getUserData : false" [inside]="false"
              [isComment]="false">
            </app-user-activity-info>

            <!-- ? Book -->
            <app-behkhaan-book-card class="w-full mt-3" [_book]="quote.book" [_horizontal]="true">
            </app-behkhaan-book-card>

            <!-- ? Quote -->
            <app-quote-item class="mt-3 w-full" [Quote]="quote"></app-quote-item>

            <!-- ? Footer -->
            <app-activity-footer-pluse class="w-full mt-3" [Activity]="quote | footerItem : false"
              [activeCommentLink]="true" (usersClicked)="openUsersDialog($event)"
              (bookmarkClicked)="bookmarkItem($event)" (likeClicked)="likeItem($event)">
            </app-activity-footer-pluse>
          </div>
        </div>

        <div *ngIf="loadingMore" class="w-full h-6 flex justify-center my-4">
          <div [appButtonLoader]="loadingMore"></div>
        </div>

      </ng-container>
    </div>
  </article>
</section>

<!-- ? Skeleton -->
<ng-template #skeletonTemplate>
  <div class="w-full pb-3 mb-3 border-b border-gray-100 dark:border-gray-600 flex flex-wrap"
    *ngFor="let item of [0, 1, 2]">
    <div class="w-full flex flex-wrap items-center">
      <ngx-skeleton-loader [appearance]="'circle'" [theme]="{ height: '48px', width: '48px' }">
      </ngx-skeleton-loader>

      <ngx-skeleton-loader class="flex mr-2" [theme]="{ height: '16px', width: '150px' }">
      </ngx-skeleton-loader>
    </div>

    <div class="w-full mt-3 flex flex-wrap">
      <ngx-skeleton-loader class="flex ratio-2-1" [theme]="{ height: '100%', width: '100%' }">
      </ngx-skeleton-loader>
    </div>
  </div>
</ng-template>